import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS } from '@measures/responsive'

const StyledPlaylistWrapper = styled.div`
  ${desktopCSS(css`
    grid-column: span 2;
    grid-template-columns: minmax(0, 1fr);
  `)}
`

const PlaylistWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  return <StyledPlaylistWrapper>{children}</StyledPlaylistWrapper>
}

export default PlaylistWrapper
